var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "statesBarContainer" },
    [
      _c("progress-bar", {
        ref: "statesBar",
        staticClass: "d-none d-lg-block my-4",
        attrs: {
          id: "states-bar",
          loading: _vm.loading,
          interactive: true,
          progress: false,
          steps: _vm.statusLabels,
          "selected-steps": _vm.currentFilters,
          "custom-render": true,
        },
        on: { change: _vm.handleProgressBarChange },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (slotProps) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "statistics-item value-item text-center clickable flex-column align-items-center",
                  },
                  [
                    _vm.editingStatus[slotProps.step.id] == null
                      ? _c(
                          "p",
                          { staticClass: "state-name regular bold text-gray" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("truncateText")(
                                    slotProps.step.stepName,
                                    _vm.TEXT_LIMIT
                                  )
                                ) +
                                "\n          "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "clickable edit-state",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.setEditing(true, slotProps.step)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-pencil no-pointer",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _c(
                          "form",
                          {
                            staticClass:
                              "client-profile-states-forms edit-state-wrapper position-relative",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                              submit: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.handleLabelSubmit(slotProps.step.id)
                              },
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.editingStatus[slotProps.step.id],
                                  expression:
                                    "editingStatus[slotProps.step.id]",
                                },
                              ],
                              ref: "editStatusInput",
                              staticClass:
                                "form-control edit-state-input text-center",
                              attrs: {
                                type: "text",
                                placeholder: "Edit state",
                                name: "label",
                              },
                              domProps: {
                                value: _vm.editingStatus[slotProps.step.id],
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.editingStatus,
                                    slotProps.step.id,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "save-state btn h-100",
                                attrs: {
                                  disabled:
                                    _vm.editingStatus[slotProps.step.id] ==
                                    null,
                                  type: "submit",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-check",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "close-edit btn h-100",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setEditing(false, slotProps.step)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-ban no-pointer",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    _c("p", { staticClass: "state-total bold text-gray" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatMoneyValue(slotProps.step.value)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "state-count text-gray small" }, [
                      _vm._v(
                        "\n          (" +
                          _vm._s(
                            slotProps.step.count +
                              " " +
                              _vm.$tc(
                                "global.doorr.client",
                                slotProps.step.count
                              )
                          ) +
                          ")\n        "
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }